import { render, staticRenderFns } from "./StatusTab.vue?vue&type=template&id=4b13e86e&scoped=true&"
import script from "./StatusTab.vue?vue&type=script&lang=js&"
export * from "./StatusTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13e86e",
  null
  
)

export default component.exports